// TODO INCONTENT-624 this file needs to be replaced with a react component
import $ from 'jquery'
import _ from 'lodash'
import View from 'view/view'
import analytics from 'service/google_analytics'

const ToggleItemsView = View.extend({
    options: {
        linkSelector: '.js-toggle-item-link',
    },

    events: {
        'click .js-toggle-item-link': 'handleItemLinkClick',
    },

    initialize() {
        _.bindAll(this, 'handleItemLinkClick')

        if (this.options.location) {
            $(`#${this.options.location}`).next().show()
        }
    },

    handleItemLinkClick(e) {
        const href = e.target.getAttribute('href')

        e.preventDefault()
        $(href).next().toggle()
        $(this.options.linkSelector).not(href).siblings().hide()

        analytics.trackPageView(window.location.pathname + window.location.hash)
    },
})

export default ToggleItemsView
